import React from 'react';
import { Text, TextProps } from '@landr/maestro';
import { css, cx } from '@landr/styled-system/css';

const cardTitleStyles = css({
    maxWidth: '100%',
    fontSize: 'sm',
    color: 'text.high',
    marginTop: 'sm',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    lineHeight: 'normal',
    position: 'relative',
});

const cardTitleCenteredStyles = css({
    textAlign: 'center',
});

interface CardTitleProps extends TextProps {
    children: React.ReactNode;
}

export const CardTitle = ({ children, ...props }: CardTitleProps) => (
    <Text className={cardTitleStyles} {...props}>
        {children}
    </Text>
);

export const CardTitleCentered = ({ children, ...props }: CardTitleProps) => (
    <Text className={cx(cardTitleStyles, cardTitleCenteredStyles)} {...props}>
        {children}
    </Text>
);
